export const RootPrefix = 'inventory_page';

export const InventoryPageSize = 6;

export enum InventoryQueryParams {
    Ordering = 'ordering',
}
